import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentState } from '../../../store/state/content.state';

@Component({
    selector: 'u4-cpp-search',
    templateUrl: './search.component.html',
    styles: []
})
export class SearchComponent implements OnInit, OnDestroy {

    @Input() placeholder: string;
    @Input() name: string;
    @Input() value: string;
    @Input() sortBy: string;
    @Input() submitText = '';
    @Input() minLength = 3;
    @Input() cssInput: string;
    @Output() searchInput: EventEmitter<{query: string; sortBy: string}> = new EventEmitter<{query: string; sortBy: string}>();

    public searchForm: UntypedFormGroup;
    public labels: { [key: string]: string };
    private searchSubject: Subject<string> = new Subject();
    private destroy$: Subject<void> = new Subject();

    constructor(private store: Store<ContentState>) { }

    ngOnInit() {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);

        this.searchForm = new UntypedFormGroup({
            input: new UntypedFormControl(
                (this.value || ''),
                [Validators.minLength(this.minLength)])
        });

        if (!this.submitText) {
            this.submitText = this.labels['general.search.placeholder'];
        }
    }

    onSubmit(): void {
        this.searchForm.markAllAsTouched(); // to trigger error if user submits form with 'enter' key

        if (this.searchForm.valid) {
            this.searchInput.emit({query: this.searchForm.get('input').value as string, sortBy: this.sortBy});
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.searchSubject.complete();
    }

}
